import { useIntl } from "react-intl";
import { useState } from "react";
import { Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useDispatch } from 'react-redux';

interface ResetAfipConnectionModalProps {
  openResetAfipConnectionModal: boolean;
  setOpenResetAfipConnectionModal: (open: boolean) => void;
  doReset:(value:boolean)=>void;
}

export default function ResetAfipConnectionModal({openResetAfipConnectionModal: resetAfipConnectionModal , setOpenResetAfipConnectionModal ,doReset}: ResetAfipConnectionModalProps) {

  const dispatch = useDispatch();
  const intl = useIntl();
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <Modal
      visible={resetAfipConnectionModal}
      setVisible={setOpenResetAfipConnectionModal}
      className="custom-modal w-auto"
      header={<h6 className="modalTitle">{`¡Atención!`}</h6>}
      footerButtonRightText = {"Coordinar"}
      footerButtonLeftText= {"Cancelar"}
      onClickLeftBtn = {()=>doReset(false)}
      onClickRightBtn={()=>doReset(true)}
      closable={false}
    >
      <div style={{ minWidth: isMobile ? "" : "150px" }}>
        <div className="flex flex-column gap-2">
          <span>{"Al modificar este dato se requerirá volver a generar la conexión con ARCA"}</span>
        </div>
      </div>
    </Modal>
  );
}
